module.exports = __webpack_public_path__ + "img/کارت-ویزیت-گلاسه-ویوی.7c4a0b83.png";